<main>
  <ng-content select="[slot-main]"></ng-content>
</main>

<aside [style.width.px]="currentWidth()">

  <ng-content select="[slot-sidebar]"></ng-content>

  <div
    class="resizer"
    cdkDrag
    (cdkDragMoved)="onDragMoved($event)">
    <span class="drag-icon">⠿</span>
  </div>

</aside>
